// import React from 'react'
// import {  useFormContext } from 'react-hook-form';
// import check from './check.png'

// function SearchOptions() {
//   const {
//     register,
//     setValue,
//     watch,
//     formState: { errors },
//   } = useFormContext();

//   // Define the fields object
//   const fields = {
//     clientInfo: {
//       srclientbday,
//       srcasestage,
//       srmainphone,
//       srmainemail,
//     },
//     caseType: {
//       SRincidentdate,
//       sropendate,
//       srcloseddate,
//       srlastaccessed,
//     },
//   };

//   // Watch the form's current values
//   const clientInfo = watch('clientInfo') || {};
//   const caseType = watch('caseType') || {};

//   return (
//     <div className="checkbox-groups">
//       {/* Client Info Group */}
//       <div className="checkbox-group">
//         <h4 style={{ fontSize: '16px', marginLeft: '15px' }}>Client Name</h4>
//         {Object.entries(clientInfo).map(([field, checked]) => (
//           <div key={field} className="checkbox-item">
//             <div className={`checkbox-container ${checked ? 'checked' : ''}`}>
//               <input
//                 type="checkbox"
//                 {...register(`clientInfo.${field}`)}
//                className ={`checkbox-secondary  ${SRincidentdateChecked ? 'checkbox-chacked-secondary' : ''}`}
//               />
//               {checked && (
//                 <span className="check-icon" style={{ height: '15px', width: '15px' }}>
//                   <img src={check} alt="check" />
//                 </span>
//               )}
//             </div>
//             <p>{field.replace(/([A-Z])/g, ' $1')}</p>
//           </div>
//         ))}
//       </div>

//       {/* Case Type Group */}
//       <div className="checkbox-group">
//         <h4 style={{ fontSize: '16px', marginLeft: '15px' }}>Case Type</h4>
//         {Object.entries(fields).map(([field, checked]) => (
//           <div key={field} className="checkbox-item">
//             <div className={`checkbox-container ${checked ? 'checked' : ''}`}>
//               <input
//                 type="checkbox"
//                 {...register(`caseType.${field}`)}
//                className ={`checkbox-secondary  ${SRincidentdateChecked ? 'checkbox-chacked-secondary' : ''}`}
//               />
//               {checked && (
//                 <span className="check-icon" style={{ height: '15px', width: '15px' }}>
//                   <img src={check} alt="check" />
//                 </span>
//               )}
//             </div>
//             <p>{field.replace(/([A-Z])/g, ' $1')}</p>
//           </div>
//         ))}
//       </div>
//     </div>
//   );
// }

// export default SearchOptions

import { useFormContext } from "react-hook-form";

function SearchOptions({ savePrefrenceCallback, setHomeData }) {
  const { register, watch } = useFormContext();

  // Watch individual fields to detect changes
  // const srclientbdayChecked = watch("srclientbday");
  const srcasestageChecked = watch("srcasestage");
  const srmainphoneChecked = watch("srmainphone");
  const srmainemailChecked = watch("srmainemail");
  // const SRincidentdateChecked = watch("SRincidentdate");
  const sropendateChecked = watch("sropendate");
  const srcloseddateChecked = watch("srcloseddate");
  const srlastaccessedChecked = watch("srlastaccessed");

  return (
    <div className="checkbox-groups" style={{ height: "max-content", gap: "40px" }}>
      {/* Client Info Group */}
      <div className="checkbox-group" style={{ gap: "15px" }}>
        <h4 style={{ fontSize: "16px", marginLeft: "0px" }}>Client Name</h4>

        {/* srclientbday */}
        <h4 style={{ fontSize: "16px", marginLeft: "0px" }}>Client Birthday with Age</h4>
        {/* <div className="checkbox-item">
          <input
            type="checkbox"
            {...register("srclientbday")}
            onChange={(e) => {
              const updatedData = {
                ...watch(),
                srclientbday: e.target.checked,
              };
              savePrefrenceCallback(updatedData);
              setHomeData(updatedData);
            }}
            className={`checkbox-secondary  ${srclientbdayChecked ? "checkbox-chacked-secondary" : ""}`}
          />
          <p>Client Birthday</p>
        </div> */}

        {/* srcasestage */}
        <div className="checkbox-item">
          <input
            type="checkbox"
            {...register("srcasestage")}
            onChange={(e) => {
              const updatedData = {
                ...watch(),
                srcasestage: e.target.checked,
              };
              savePrefrenceCallback(updatedData);
              setHomeData(updatedData);
            }}
            className={`checkbox-secondary  ${srcasestageChecked ? "checkbox-chacked-secondary" : ""}`}
          />
          <p>Case Stage</p>
        </div>

        {/* srmainphone */}
        <div className="checkbox-item">
          <input
            type="checkbox"
            {...register("srmainphone")}
            onChange={(e) => {
              const updatedData = {
                ...watch(),
                srmainphone: e.target.checked,
              };
              savePrefrenceCallback(updatedData);
              setHomeData(updatedData);
            }}
            className={`checkbox-secondary  ${srmainphoneChecked ? "checkbox-chacked-secondary" : ""}`}
          />
          <p>Main Phone</p>
        </div>

        {/* srmainemail */}
        <div className="checkbox-item">
          <input
            type="checkbox"
            {...register("srmainemail")}
            onChange={(e) => {
              const updatedData = {
                ...watch(),
                srmainemail: e.target.checked,
              };
              savePrefrenceCallback(updatedData);
              setHomeData(updatedData);
            }}
            className={`checkbox-secondary  ${srmainemailChecked ? "checkbox-chacked-secondary" : ""}`}
          />
          <p>Main Email</p>
        </div>
      </div>

      {/* Case Type Group */}
      <div className="checkbox-group" style={{ gap: "15px" }}>
        <h4 style={{ fontSize: "16px", marginLeft: "0px" }}>Case Type</h4>
        <h4 style={{ fontSize: "16px", marginLeft: "0px" }}>Incident Date</h4>
        {/* <div className="checkbox-item">
          <input
            className={`checkbox-secondary  ${SRincidentdateChecked ? "checkbox-chacked-secondary" : ""}`}
            type="checkbox"
            {...register("SRincidentdate")}
            onChange={(e) => {
              const updatedData = {
                ...watch(),
                SRincidentdate: e.target.checked,
              };
              savePrefrenceCallback(updatedData);
              setHomeData(updatedData);
            }}
          />

          <p>Incident Date</p>
        </div> */}

        {/* sropendate */}
        <div className="checkbox-item">
          <input
            type="checkbox"
            {...register("sropendate")}
            onChange={(e) => {
              const updatedData = {
                ...watch(),
                sropendate: e.target.checked,
              };
              savePrefrenceCallback(updatedData);
              setHomeData(updatedData);
            }}
            className={`checkbox-secondary  ${sropendateChecked ? "checkbox-chacked-secondary" : ""}`}
          />

          <p>Open Date</p>
        </div>

        {/* srcloseddate */}
        <div className="checkbox-item">
          <input
            type="checkbox"
            {...register("srcloseddate")}
            onChange={(e) => {
              const updatedData = {
                ...watch(),
                srcloseddate: e.target.checked,
              };
              savePrefrenceCallback(updatedData);
              setHomeData(updatedData);
            }}
            className={`checkbox-secondary  ${srcloseddateChecked ? "checkbox-chacked-secondary" : ""}`}
          />
          <p>Closed Date</p>
        </div>

        <div className="checkbox-item">
          <input
            type="checkbox"
            {...register("srlastaccessed")}
            onChange={(e) => {
              const updatedData = {
                ...watch(),
                srlastaccessed: e.target.checked,
              };
              savePrefrenceCallback(updatedData);
              setHomeData(updatedData);
            }}
            className={`checkbox-secondary  ${srlastaccessedChecked ? "checkbox-chacked-secondary" : ""}`}
          />
          <p>Last Accessed</p>
        </div>
      </div>
    </div>
  );
}

export default SearchOptions;
